import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withLang } from '../../../i18n';
import SubmitSurvey from '../SubmitSurvey';
import ConfirmButton from '../../ConfirmButton';
import {
  clearSurveyAction,
  clearCourseUnitRealizationsAction
} from '../../../actions';
import { routes } from '../../../constants';
import withRouter from '../../WithRouter';

import styles from './formNavigation.module.css';

const renderNavigationLink = (to, iconClass, text) => (
  <Link
    className={`button--action ${iconClass}`}
    to={to}
    data-cy="navigation-link"
  >{text}
  </Link>
);

class FormNavigation extends Component {
  constructor(props) {
    super(props);

    this.cancel = this.cancel.bind(this);
    this.renderPrevPageButton = this.renderPrevPageButton.bind(this);
    this.renderProceedButton = this.renderProceedButton.bind(this);
  }

  cancel() {
    this.props.dispatchClear();
    this.props.navigate(routes.index);
  }

  renderPrevPageButton() {
    const t = this.props.translate;
    if (this.props.previous) {
      return renderNavigationLink(this.props.previous, 'icon--arrow-left', t('common.previous'));
    }
    return null;
  }

  renderProceedButton() {
    const t = this.props.translate;
    if (this.props.canProceed && this.props.submit) {
      return <SubmitSurvey />;
    } if (this.props.canProceed) {
      return renderNavigationLink(this.props.next, 'icon--arrow-right', t('common.next'));
    }
    return (
      <button
        type="button"
        className="button--action icon--square-checked"
        onClick={this.props.showProblemsFunc}
      >
        {t('common.verifyFormData')}
      </button>
    );
  }

  render() {
    const t = this.props.translate;

    return (
      <nav className={styles.navigation}>
        {this.renderPrevPageButton()}
        <ConfirmButton modalText={t('confirmButton.confirmCancel')} onConfirm={this.cancel}>
          {t('common.cancel')}
        </ConfirmButton>
        {this.renderProceedButton()}
      </nav>
    );
  }
}

const {
  string, bool, func
} = PropTypes;
FormNavigation.propTypes = {
  canProceed: bool.isRequired,
  showProblemsFunc: func,
  translate: func.isRequired,
  next: string,
  previous: string,
  submit: bool,
  dispatchClear: func.isRequired,
  navigate: func.isRequired
};

FormNavigation.defaultProps = {
  submit: false,
  next: '',
  previous: '',
  showProblemsFunc: () => {}
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  dispatchClear: () => {
    dispatch(clearSurveyAction());
    dispatch(clearCourseUnitRealizationsAction());
  }
});

export default withLang(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(FormNavigation))
);
